<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-33@lg-and-up c-cell c-cell--isolated" *ngFor="let appointment of vm.appointments">
		<card-appointment [appointment]="appointment"></card-appointment>
	</div>
</div>
